export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const GO_BACK_MODAL = "GO_BACK_MODAL";
export const ADD_STACK_MODAL = "ADD_STACK_MODAL";
